import { register } from '@shopify/theme-sections'
import '../../styles/sections/section-accordion-two-columns-v2.scss'
import {renderDualAccordions} from "@/scripts/modules/detail-accordion"


export default register(`section-accordion-two-columns-v2`, {
  onLoad() {
    renderDualAccordions(`section-accordion-two-columns-v2`, `all`)
  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
  },
})

